<template>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "BannerUnsubscribedUser",
  created(){
      this.showBanner();
  },
   computed :{
    ...mapState("auth", ["user"]),
  } , methods: {
    showBanner(){
        this.$swal
          .fire({
            title: `<b><p style = ' color: #1c4c91;'> ${this.$t('messages.general.subscribe_today')}</p></b>`,
            html:`<b></b><p style = ' color: #00649B;'> ${ this.$t('messages.general.subscribe_message_mini')}</p></b>`,
            width: 760,

            confirmButtonText: this.$t('messages.general.subscribe'),
            confirmButtonColor: '#1C4C91',
            background: 'center #EFF3F2 url(https://jwperfectmatch.com/storage/image/banner-profile-subscribe.webp) no-repeat'
          }).then(result =>{
              if (result.value) {
                this.$router.push('../subscriptions');
              }
            });
    }
  }
};
</script>

